/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IRadiologyStudy } from 'app/shared/model/radiology-study.model';

export interface IRadiologyReport {
  id?: string;
  reportStatus?: string | null;
  reportDate?: number | null;
  reportBody?: string | null;
  voided?: boolean | null;
  dateVoided?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  reporter?: IDoctor | null;
  patient?: IGlucoUser | null;
  study?: IRadiologyStudy;
}

export const defaultValue: Readonly<IRadiologyReport> = {
  voided: false,
  active: false,
};
